import { useState, useEffect } from "react";
import { api } from "@/lib/galleryApi";

let cache = null;

// Studio rights come from the backend (which enforces them on every call); this only drives what is shown
export function useStudioPerms() {
  const [perms, setPerms] = useState(cache);
  useEffect(() => {
    api.get("/photo-studio/me").then((p) => { cache = p; setPerms(p); }).catch(() => setPerms({ studio: false, client: false, super_admin: false }));
  }, []);
  return perms;
}
